import { StyleSheet } from 'aphrodite';

// tslint:disable:object-literal-key-quotes

export const styleSheet = StyleSheet.create({
	container: {
	},
});
